import { useParams, Link } from 'react-router-dom';
import './../../pagescss/SubjectTopics.css';
import Number from './QuizYearNumber';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';
import { useEffect, useState } from 'react';
import UsePayments from '../AdminPanel/UsePayments';
import PaidItems from '../AllData/PaidItems';


function QuizYear() {
    const { type, subject, topic, subjectName } = useParams();
    const [submisstion, setSubmissions] = useState([]);

    // Check payment
    const { allPayments, loading } = UsePayments();
    const userPhone = localStorage.getItem('userPhone');
    // const isPayment = allPayments.find(payment => payment.phone === userPhone);
    const isPayment = localStorage.getItem('userPayment');

    const paidItems = PaidItems;
    const isPaid = paidItems.includes(type);

    const demoTopics = [];
    const isDemo = (topic) => {
        return demoTopics.includes(topic);
    }


    useEffect(() => {
        const saved = localStorage.getItem('quizSubmissions');
        const data = saved ? JSON.parse(saved) : [];
        setSubmissions(data);
    }, []);


    let quizLimit;
    if (subject !== "atoz" && topic !== "atoz") {
        quizLimit = 6;
    } else if (subject !== "atoz" && topic === "atoz") {
        quizLimit = 20;
    } else {
        quizLimit = 30;
    }

    //  if (loading) {
    //      return <Loading message='Loading......' />;
    //   }

    return (
        <div className="subject-topics-page">


            {subject === "atoz" ? (
                <><TopNavbar name="Full mock test all subject" /></>
            ) : (
                topic === "atoz" ? (
                    <><TopNavbar name={"Full mock test for " + subject} /></>
                ) : (
                    <><TopNavbar name={"Full mock test for " + subjectName} /></>
                )
            )}

            {subject === "atoz" ? (
                <><TopHeader name="Full mock test all subject" /></>
            ) : (
                topic === "atoz" ? (
                    <><TopHeader name={"Full mock test for " + subject} /></>
                ) : (
                    <><TopHeader name={"Full mock test for " + subjectName} /></>
                )
            )}

            <div className="topics-container">
                {Number.slice(0, quizLimit).map((quizNum, index) => {
                    const quizId = `${type}${subject}${topic}${quizNum.quizNo}`;
                    const userSubmission = submisstion?.find(
                        submission => submission.quizId === quizId
                    );
                    const isUserQuiz = !!userSubmission;

                    // Safely extract data with fallbacks
                    const score = isUserQuiz ? (userSubmission?.score || 0) : null;
                    const totalQuestions = isUserQuiz ? (userSubmission?.totalQuestions || 0) : null;
                    const percentage = isUserQuiz && totalQuestions > 0
                        ? Math.round((score * 100) / (totalQuestions * 4))
                        : 0;

                    return (
                        <div key={quizNum.id || quizNum.quizNo}>


                            {isPayment || !isPaid || isDemo(quizNum.quizNo) ? (<>
                                {isUserQuiz ? (
                                    <Link
                                        //  to={`/quiz-details/${type}/${quizId}`}
                                        to={`/quiz-details/${quizId}/${type}/${subject}/${topic}/${quizNum.quizNo}/${subjectName}`}

                                        className="link"
                                    >
                                        <div className="topic-card-mocktest-complete">
                                            <div className="topic-header">
                                                <h2>📜{quizNum.quizNo}: {subjectName} mock test</h2>
                                            </div>
                                            <p>complete: Score: {score}/{totalQuestions * 4} ({percentage}%)</p>
                                        </div>
                                    </Link>
                                ) : (
                                    <Link
                                        to={`/number-of-questions-year/${type}/${subject}/${topic}/${quizNum.quizNo}/${subjectName}`}
                                        // to={`/number-of-questions/${type}/${subject}/${topic}/${quizNum.quizNo}/${subjectName}`}

                                        className="link"
                                    >
                                        <div className="topic-card">
                                            <div className="topic-header">
                                                <h2>📜{quizNum.quizNo}: {subjectName} mock test</h2>
                                            </div>
                                        </div>
                                    </Link>
                                )}
                            </>) : (<>
                                {isUserQuiz ? (
                                    <Link
                                        to="/premium-paywall"
                                        className="link"
                                    >
                                        <div className="topic-card-mocktest-complete">
                                            <div className="topic-header">
                                                <h2>📜{quizNum.quizNo}: {subjectName} mock test </h2><h2>🔒</h2>
                                            </div>
                                            <p>complete: Score: {score}/{totalQuestions * 4} ({percentage}%)</p>
                                        </div>
                                    </Link>
                                ) : (
                                    <Link
                                        to="/premium-paywall"
                                        className="link"
                                    >
                                        <div className="topic-card">
                                            <div className="topic-header">
                                                <h2>📜{quizNum.quizNo}: {subjectName} mock test </h2> <h2>🔒</h2>
                                            </div>
                                        </div>
                                    </Link>
                                )}
                            </>)}

                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default QuizYear;